import type { GetFunctionArgs } from "@eulerxyz/core-sdk"
import type { Abi, ExtractAbiFunctionNames } from "abitype"
import {
  type Address,
  ContractFunctionRevertedError,
  ContractFunctionZeroDataError,
  type Hex,
} from "viem"
import { getContractError } from "viem/utils"

type CreateContractErrorArgs<
  abi extends Abi,
  functionName extends ExtractAbiFunctionNames<abi extends Abi ? abi : Abi>,
> = {
  abi: abi
  data: Hex
  functionName: functionName
  address: Address
  sender?: Address
} & GetFunctionArgs<abi, functionName>

export function createContractError<
  abi extends Abi = Abi,
  functionName extends ExtractAbiFunctionNames<
    abi extends Abi ? abi : Abi
  > = string,
>({
  abi,
  address,
  data,
  functionName,
  args,
  sender,
}: CreateContractErrorArgs<abi, functionName>) {
  let cause: ContractFunctionRevertedError | ContractFunctionZeroDataError

  if (data === "0x") {
    cause = new ContractFunctionZeroDataError({
      functionName,
    })
  } else {
    cause = new ContractFunctionRevertedError({
      abi,
      data,
      functionName,
    })
  }

  return getContractError(cause, {
    abi,
    args,
    functionName,
    address,
    sender,
  })
}
